const KEY_PREFIX = 'supplier-chunk-reload:'

export function installChunkReload(router) {
  let pendingTarget = null

  router.beforeEach((to) => {
    pendingTarget = to.fullPath
  })

  router.afterEach((to, _from, failure) => {
    pendingTarget = null
    if (failure) return
    try {
      sessionStorage.removeItem(`${KEY_PREFIX}${to.fullPath}`)
    } catch (error) {
      console.error(error)
    }
  })

  window.addEventListener('vite:preloadError', () => {
    const target = pendingTarget ?? `${window.location.pathname}${window.location.search}`
    const key = `${KEY_PREFIX}${target}`
    try {
      if (sessionStorage.getItem(key)) return
      sessionStorage.setItem(key, '1')
    } catch (error) {
      console.error(error)
      return
    }
    window.location.assign(target)
  })
}
